import VueDatePicker from "@vuepic/vue-datepicker";
import { defineNuxtPlugin } from "#imports";
// to not import because it is imported from the main.scss
// import '@vuepic/vue-datepicker/dist/main.css';

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.component("VueDatePicker", VueDatePicker);
});
